import React, { useState, useEffect } from 'react';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const FilterTimeRange = React.memo(({
  field_name,
  selectedItems,
  setSelectedItems,
  addNode,
  removeNode,
  updateNode,
  path,
  pathExists,
}) => {
  const [startTime, setStartTime] = useState(selectedItems[field_name]?.start || null);
  const [endTime, setEndTime] = useState(selectedItems[field_name]?.end || null);

  const fullPath = [...path, { key: field_name, value: 0 }];

  const handleStartTimeClose = () => {
    processNodeChanges();
  };

  const handleEndTimeClose = () => {
    processNodeChanges();
  };

  const convertToMinutes = (time) => {
    if (!time) return null;
    const hours = time.hour();
    const minutes = time.minute();
    return hours * 60 + minutes;
  };

  const processNodeChanges = () => {

    const startMinutes = convertToMinutes(startTime);
    const endMinutes = convertToMinutes(endTime);

    if (startTime && endTime) {
      // When both times are set, add or update the node
      if (pathExists(fullPath)) {
        updateNode(fullPath, { is_group: 0, min: startMinutes, max: endMinutes }, field_name);
      } else {
        addNode(fullPath, { is_group: 0, min: startMinutes, max: endMinutes });
      }
      setSelectedItems((prev) => ({
        ...prev,
        [field_name]: { start: startTime, end: endTime },
      }));
    } else if ((!startTime || !endTime) && pathExists(fullPath)) {
      // Only remove the node if the path exists and either time is cleared
      removeNode(fullPath);
      setSelectedItems((prev) => {
        const { [field_name]: _, ...rest } = prev; // Destructure to omit `field_name`
        return rest; // Return the updated object without `field_name`
      });
    }
  };

  const handleStartTimeChange = (newValue) => {
    setStartTime(newValue);
  };

  const handleEndTimeChange = (newValue) => {
    setEndTime(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <TimePicker
          label="Start"
          value={startTime}
          maxTime={endTime}
          onChange={handleStartTimeChange}
          onClose={handleStartTimeClose} // Process changes on close
          slotProps={{
            textField: {
              size: 'small',
              sx: {
                '& .MuiOutlinedInput-root': {
                  border: '1px solid #B4B4B4',
                  color: '#000',
                  fontFamily: 'Sfpro400',
                  fontSize: '12px',
                  letterSpacing: '1.26px',
                  outline: 'unset',
                  width: '100%',
                  padding: '0px 5px',
                  borderRadius: '5px',
                },
                '& .MuiInputLabel-root': {
                  fontSize: '13px',
                },
              },
            },
          }}
        />
        <TimePicker
          label="End"
          value={endTime}
          minTime={startTime} // Ensures End Time is after Start Time
          onChange={handleEndTimeChange}
          onClose={handleEndTimeClose} // Process changes on close
          slotProps={{
            textField: {
              size: 'small',
              sx: {
                '& .MuiOutlinedInput-root': {
                  border: '1px solid #B4B4B4',
                  color: '#000',
                  fontFamily: 'Sfpro400',
                  fontSize: '12px',
                  letterSpacing: '1.26px',
                  outline: 'unset',
                  width: '100%',
                  padding: '0px 5px',
                  borderRadius: '5px',
                },
                '& .MuiInputLabel-root': {
                  fontSize: '13px',
                },
              },
            },
          }}
        />
      </div>
    </LocalizationProvider>
  );
});

export default FilterTimeRange;
